import React from 'react'
import '../../css/coopmarquee.css'

const CoopMarquee = () => {
    return (
        <>
            <div className='coop-marquee'>
                <div className='marquee-text'>
                    <div className='marquee-content'>
                        <strong><span>" कनकलक्ष्मी बचत तथा ऋण सहकारी संस्था लि. को आधिकारीक वेबसाइटमा यहाँहरुलाई हार्दिक स्वागत गर्दछौं । " - कनकलक्ष्मी साकोस परिवार</span></strong>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CoopMarquee